import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { COLORS } from '../utils/constants';
import useAuth from '../hooks/useAuth';

const VerifyEmail = () => {
  const [resending, setResending] = useState(false);
  const navigate = useNavigate();
  const { user, resendVerification, logout } = useAuth();

  const handleResendEmail = async () => {
    if (!user?.email) return;

    setResending(true);
    try {
      await resendVerification(user.email);
    } finally {
      setResending(false);
    }
  };

  const handleLogout = async () => {
    await logout();
    navigate('/signin');
  };

  return (
    <div style={{
      display: 'flex',
      minHeight: '100vh',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#f9fafb',
      padding: '20px',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
    }}>
      <div style={{
        backgroundColor: COLORS.white,
        borderRadius: '16px',
        padding: '48px',
        maxWidth: '480px',
        width: '100%',
        boxShadow: '0 10px 40px rgba(0, 0, 0, 0.1)',
        textAlign: 'center'
      }}>
        {/* Email Icon */}
        <div style={{
          width: '80px',
          height: '80px',
          backgroundColor: '#DBEAFE',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 24px',
        }}>
          <svg 
            width="40" 
            height="40" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke={COLORS.blue}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
            <polyline points="22,6 12,13 2,6" />
          </svg>
        </div>

        {/* Heading */}
        <h1 style={{
          fontSize: '28px',
          fontWeight: '700',
          color: COLORS.black,
          marginBottom: '12px'
        }}>
          Verify Your Email
        </h1>

        {/* Description */}
        <p style={{
          fontSize: '16px',
          color: COLORS.gray,
          lineHeight: '1.6',
          marginBottom: '8px'
        }}>
          We've sent a verification link to
        </p>
        <p style={{
          fontSize: '16px',
          fontWeight: '600',
          color: COLORS.black,
          marginBottom: '24px'
        }}>
          {user?.email || 'your email'}
        </p>

        <p style={{
          fontSize: '14px',
          color: COLORS.gray,
          lineHeight: '1.6',
          marginBottom: '32px'
        }}>
          Click the link in the email to verify your account. If you don't see the email, check your spam folder.
        </p>

        {/* Resend Button */}
        <button
          onClick={handleResendEmail}
          disabled={resending}
          style={{
            width: '100%',
            padding: '14px',
            backgroundColor: resending ? COLORS.gray : COLORS.blue,
            color: COLORS.white,
            border: 'none',
            borderRadius: '12px',
            fontSize: '15px',
            fontWeight: '600',
            cursor: resending ? 'not-allowed' : 'pointer',
            marginBottom: '12px',
            transition: 'all 0.3s ease',
            opacity: resending ? 0.6 : 1
          }}
          onMouseEnter={(e) => {
            if (!resending) {
              e.target.style.transform = 'translateY(-2px)';
            }
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = 'translateY(0)';
          }}
        >
          {resending ? 'Sending...' : 'Resend Verification Email'}
        </button>

        {/* Logout Button */}
        <button
          onClick={handleLogout}
          style={{
            width: '100%',
            padding: '14px',
            backgroundColor: 'transparent',
            color: COLORS.gray,
            border: `2px solid ${COLORS.lightGray}`,
            borderRadius: '12px',
            fontSize: '15px',
            fontWeight: '600',
            cursor: 'pointer',
            transition: 'all 0.3s ease'
          }}
          onMouseEnter={(e) => {
            e.target.style.borderColor = COLORS.gray;
          }}
          onMouseLeave={(e) => {
            e.target.style.borderColor = COLORS.lightGray;
          }}
        >
          Logout
        </button>

        {/* Help Text */}
        <p style={{
          fontSize: '13px',
          color: COLORS.gray,
          marginTop: '24px',
          lineHeight: '1.5'
        }}>
          Need help? Contact us at{' '}
          <a 
            href="mailto:support@fyloforms.com"
            style={{
              color: COLORS.blue,
              textDecoration: 'none',
              fontWeight: '600'
            }}
          >
            support@fylo.com
          </a>
        </p>
      </div>
    </div>
  );
};

export default VerifyEmail;